import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { Icon, usePageMeta, PageHero, FinalCTA, Eyebrow } from "../components/Shared";
import { VALUES, IMAGES } from "../data/site";

export default function About() {
  usePageMeta("About Us", "CoreDock Logistics is a responsive freight-handling partner in Mississauga, keeping freight moving through dependable handling, clear communication, and flexible logistics solutions.");
  return (
    <>
      <PageHero eyebrow="About CoreDock" image={IMAGES.facility}
        title="A Freight Partner Built for the GTA"
        subtitle="CoreDock Logistics was created to give carriers, brokers, shippers, and local businesses a responsive freight-handling partner in Mississauga." />

      <section className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <Reveal className="relative overflow-hidden border-4 border-navy">
            <img src={IMAGES.forklift} alt="Freight handling at CoreDock" className="w-full h-[440px] object-cover" />
          </Reveal>
          <Reveal delay={0.15}>
            <Eyebrow>Our Mission</Eyebrow>
            <p className="font-display font-bold text-2xl md:text-3xl leading-tight mt-4">
              "Our mission is to keep freight moving through dependable handling, clear communication,
              and flexible logistics solutions."
            </p>
            <p className="mt-6 text-text-secondary leading-relaxed">
              From our approximately 3,500 sq. ft. facility with two loading docks — close to Highway 401
              and Toronto Pearson Airport — we provide cross-docking, short-term warehousing, freight
              handling, and pickup-and-delivery solutions for freight moving through the region.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-white border-y border-border py-20 md:py-28">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <Reveal className="mb-14 max-w-2xl">
            <Eyebrow>Core Values</Eyebrow>
            <h2 className="font-display font-bold tracking-tight text-3xl md:text-5xl mt-3">What we stand for</h2>
          </Reveal>
          <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
            {VALUES.map((v, i) => (
              <StaggerItem key={v.title} className="border-t-2 border-navy pt-6">
                <span className="font-mono text-orange text-sm">{String(i + 1).padStart(2, "0")}</span>
                <Icon name={v.icon} size={28} strokeWidth={1.5} className="text-navy mt-4" />
                <h3 className="font-display font-bold text-xl mt-4">{v.title}</h3>
                <p className="mt-2 text-sm text-text-secondary leading-relaxed">{v.desc}</p>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      {/* Editable placeholder block */}
      <section className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 md:py-24">
        <Reveal className="bg-offwhite border border-dashed border-navy/30 p-8 md:p-10">
          <span className="tag-eyebrow">Editable Placeholder</span>
          <h3 className="font-display font-bold text-2xl mt-3">Company Story &amp; Credentials</h3>
          <p className="mt-3 text-text-secondary leading-relaxed max-w-3xl">
            This space is reserved for your company history, certifications, team members, and milestones.
            We haven't invented any of these details — update this section any time with accurate,
            verified information about CoreDock Logistics.
          </p>
        </Reveal>
      </section>

      <FinalCTA />
    </>
  );
}
